export const LoginName = 'loginComponent';
